import { Typography } from 'design_system/src';
import SelectorGroup from 'design_system/src/components/SelectorGroup/SelectorGroup';
import useProviders from 'hooks/useProviders';
import { Sku } from 'models/sku/interfaces/sku.interface';
import { SkuVariant } from 'models/sku-variant/interfaces/sku-variant.interface';
import { getGenericMotoImageUrl } from 'models/upload/publicStorage';
import { variantLabel } from 'models/sku-variant/helpers/skuVariantLabel';

interface CardSkuProps {
	sku: Sku;
	onClick: (sku: Sku, variant: SkuVariant) => void;
	selectedVariantId?: string;
	selected?: boolean;
}

function CardSku({ sku, onClick, selectedVariantId, selected }: CardSkuProps) {
	const imageUrl = sku.images?.[0]?.url ?? getGenericMotoImageUrl();
	const variants = sku.variants ?? [];
	const providers = useProviders();

	const handleSelectVariant = (variantId: string) => {
		const variant = variants.find((v) => v._id === variantId);
		if (variant) onClick(sku, variant);
	};

	return (
		<div
			className={`dso_card flex_center_col bg_neutral_0 dim_100_per p_xs ${
				selected ? 'border_1 border_primary_300' : ''
			}`}
		>
			<div className="flex_1 w_100_per">
				<img
					src={imageUrl}
					alt={sku.code}
					className="w_100_per center_y br_sm moto_img"
				/>
			</div>
			<div className="flex_center_col w_100_per p_t_sm">
				<Typography
					scale="xsmall"
					weight="600"
					textColor="primary_300"
					className="text_center"
				>
					{sku.code}
				</Typography>
				<Typography
					scale="medium"
					weight="600"
					textColor="neutral_1000"
					className="text_center text_uppercase m_b_xxs"
				>
					{`${sku.brandName} ${sku.modelName} ${sku.year}`}
				</Typography>
				<Typography
					scale="xsmall"
					weight="400"
					textColor="neutral_600"
					className="text_center m_b_xs"
				>
					{sku.cc} cc{sku.version ? ` · ${sku.version}` : ''}
				</Typography>

				{variants.length > 0 ? (
					<div className="w_100_per m_b_xs">
						<SelectorGroup
							multiple={false}
							orientation="horizontal"
							className="flex_justify_center flex_wrap flex_gap_xxs"
							value={selectedVariantId ? [selectedVariantId] : []}
							options={variants.map((variant) => ({
								id: variant._id,
								text: variantLabel(variant, providers),
							}))}
							onChange={(selectedIds) =>
								handleSelectVariant(selectedIds[0] as string)
							}
						/>
					</div>
				) : (
					<Typography
						scale="xsmall"
						weight="400"
						textColor="neutral_600"
						className="text_center m_b_xs"
					>
						Sin variantes disponibles
					</Typography>
				)}
			</div>
		</div>
	);
}

export default CardSku;
